import { j as pe } from "./jsx-runtime-p91LotPX.mjs";
import { getAvatarColor as me } from "./BaseComponents/Avatar/predicate.js";
import * as r from "react";
import { g as K, m as q, b as U, u as ue, Q as ge, a as V, s as Q, q as R } from "./index-CjjiqU7h.mjs";
import { R as ve } from "./index-BgcNEpwc.mjs";
import { u as fe, r as ye } from "./useBreakpoint-C_VPG-kZ.mjs";
import { a as Y, u as he } from "./useCSSVarCls--o7XUl-F.mjs";
import { u as Ce } from "./Compact-8zmhZt2C.mjs";
import { t as xe } from "./toArray-C1Af_up9.mjs";
import { c as Z } from "./reactNode-CwSzDQK_.mjs";
import { g as Se, K as be } from "./motion-P3tHGbiP.mjs";
import { g as Oe, a as Pe, b as $e, P as Ee, T as Ne } from "./index-BP092b3A.mjs";
import "./index-z2Yki-8P.mjs";
import { i as ze } from "./zoom-DWyN4gat.mjs";
import { P as we } from "./colors-CS1uQ7ve.mjs";
const je = /* @__PURE__ */ r.createContext({}), G = je, ke = (e) => {
  const {
    antCls: o,
    componentCls: n,
    iconCls: t,
    avatarBg: a,
    avatarColor: l,
    containerSize: d,
    containerSizeLG: g,
    containerSizeSM: p,
    textFontSize: y,
    textFontSizeLG: v,
    textFontSizeSM: O,
    borderRadius: f,
    borderRadiusLG: m,
    borderRadiusSM: x,
    lineWidth: C,
    lineType: w
  } = e, s = (P, S, j) => ({
    width: P,
    height: P,
    borderRadius: "50%",
    [`&${n}-square`]: {
      borderRadius: j
    },
    [`&${n}-icon`]: {
      fontSize: S,
      [`> ${t}`]: {
        margin: 0
      }
    }
  });
  return {
    [n]: Object.assign(Object.assign(Object.assign(Object.assign({}, U(e)), {
      position: "relative",
      display: "inline-flex",
      justifyContent: "center",
      alignItems: "center",
      overflow: "hidden",
      color: l,
      whiteSpace: "nowrap",
      textAlign: "center",
      verticalAlign: "middle",
      background: a,
      border: `${ue(C)} ${w} transparent`,
      "&-image": {
        background: "transparent"
      },
      [`${o}-image-img`]: {
        display: "block"
      }
    }), s(d, y, f)), {
      "&-lg": Object.assign({}, s(g, v, m)),
      "&-sm": Object.assign({}, s(p, O, x)),
      "> img": {
        display: "block",
        width: "100%",
        height: "100%",
        objectFit: "cover"
      }
    })
  };
}, _e = (e) => {
  const {
    componentCls: o,
    groupBorderColor: n,
    groupOverlapping: t,
    groupSpace: a
  } = e;
  return {
    [`${o}-group`]: {
      display: "inline-flex",
      [`${o}`]: {
        borderColor: n
      },
      "> *:not(:first-child)": {
        marginInlineStart: t
      }
    },
    [`${o}-group-popover`]: {
      [`${o} + ${o}`]: {
        marginInlineStart: a
      }
    }
  };
}, Re = (e) => {
  const {
    controlHeight: o,
    controlHeightLG: n,
    controlHeightSM: t,
    fontSize: a,
    fontSizeLG: l,
    fontSizeXL: d,
    fontSizeHeading3: g,
    marginXS: p,
    marginXXS: y,
    colorBorderBg: v
  } = e;
  return {
    containerSize: o,
    containerSizeLG: n,
    containerSizeSM: t,
    textFontSize: Math.round((l + d) / 2),
    textFontSizeLG: g,
    textFontSizeSM: a,
    groupSpace: y,
    groupOverlapping: -p,
    groupBorderColor: v
  };
}, J = K("Avatar", (e) => {
  const {
    colorTextLightSolid: o,
    colorTextPlaceholder: n
  } = e, t = q(e, {
    avatarBg: n,
    avatarColor: o
  });
  return [ke(t), _e(t)];
}, Re);
var Be = function(e, o) {
  var n = {};
  for (var t in e)
    Object.prototype.hasOwnProperty.call(e, t) && o.indexOf(t) < 0 && (n[t] = e[t]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, t = Object.getOwnPropertySymbols(e); a < t.length; a++)
      o.indexOf(t[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, t[a]) && (n[t[a]] = e[t[a]]);
  return n;
};
const Ie = (e, o) => {
  const [n, t] = r.useState(1), [a, l] = r.useState(!1), [d, g] = r.useState(!0), p = r.useRef(null), y = r.useRef(null), v = ge(o, p), {
    getPrefixCls: O,
    avatar: f
  } = r.useContext(V), m = r.useContext(G), x = () => {
    if (!y.current || !p.current)
      return;
    const u = y.current.offsetWidth, h = p.current.offsetWidth;
    if (u !== 0 && h !== 0) {
      const {
        gap: z = 4
      } = e;
      z * 2 < h && t(h - z * 2 < u ? (h - z * 2) / u : 1);
    }
  };
  r.useEffect(() => {
    l(!0);
  }, []), r.useEffect(() => {
    g(!0), t(1);
  }, [e.src]), r.useEffect(x, [e.gap]);
  const C = () => {
    const {
      onError: u
    } = e;
    (u == null ? void 0 : u()) !== !1 && g(!1);
  }, {
    prefixCls: w,
    shape: s,
    size: P,
    src: S,
    srcSet: j,
    icon: b,
    className: T,
    rootClassName: A,
    alt: B,
    draggable: N,
    children: E,
    crossOrigin: k
  } = e, i = Be(e, ["prefixCls", "shape", "size", "src", "srcSet", "icon", "className", "rootClassName", "alt", "draggable", "children", "crossOrigin"]), c = Ce((u) => {
    var h, z;
    return (z = (h = P ?? (m == null ? void 0 : m.size)) !== null && h !== void 0 ? h : u) !== null && z !== void 0 ? z : "default";
  }), _ = Object.keys(typeof c == "object" ? c || {} : {}).some((u) => ["xs", "sm", "md", "lg", "xl", "xxl"].includes(u)), W = fe(_), D = r.useMemo(() => {
    if (typeof c != "object")
      return {};
    const u = ye.find((z) => W[z]), h = c[u];
    return h ? {
      width: h,
      height: h,
      fontSize: h && (b || E) ? h / 2 : 18
    } : {};
  }, [W, c]);
  if (process.env.NODE_ENV !== "production") {
    const u = Q("Avatar");
    process.env.NODE_ENV !== "production" && u(!(typeof b == "string" && b.length > 2), "breaking", `\`icon\` is using ReactNode instead of string naming in v4. Please check \`${b}\` at https://ant.design/components/icon`);
  }
  const $ = O("avatar", w), F = Y($), [re, ae, se] = J($, F), ie = R({
    [`${$}-lg`]: c === "large",
    [`${$}-sm`]: c === "small"
  }), H = /* @__PURE__ */ r.isValidElement(S), le = s || (m == null ? void 0 : m.shape) || "circle", ce = R($, ie, f == null ? void 0 : f.className, `${$}-${le}`, {
    [`${$}-image`]: H || S && d,
    [`${$}-icon`]: !!b
  }, se, F, T, A, ae), de = typeof c == "number" ? {
    width: c,
    height: c,
    fontSize: b ? c / 2 : 18
  } : {};
  let I;
  if (typeof S == "string" && d)
    I = /* @__PURE__ */ r.createElement("img", {
      src: S,
      draggable: N,
      srcSet: j,
      onError: C,
      alt: B,
      crossOrigin: k
    });
  else if (H)
    I = S;
  else if (b)
    I = b;
  else if (a || n !== 1) {
    const u = `scale(${n})`, h = {
      msTransform: u,
      WebkitTransform: u,
      transform: u
    };
    I = /* @__PURE__ */ r.createElement(ve, {
      onResize: x
    }, /* @__PURE__ */ r.createElement("span", {
      className: `${$}-string`,
      ref: y,
      style: Object.assign({}, h)
    }, E));
  } else
    I = /* @__PURE__ */ r.createElement("span", {
      className: `${$}-string`,
      style: {
        opacity: 0
      },
      ref: y
    }, E);
  return delete i.onError, delete i.gap, re(/* @__PURE__ */ r.createElement("span", Object.assign({}, i, {
    style: Object.assign(Object.assign(Object.assign(Object.assign({}, de), D), f == null ? void 0 : f.style), i.style),
    className: ce,
    ref: v
  }), I));
}, ee = /* @__PURE__ */ r.forwardRef(Ie);
process.env.NODE_ENV !== "production" && (ee.displayName = "Avatar");
const te = ee, M = (e) => e ? typeof e == "function" ? e() : e : null, Te = (e) => {
  const {
    componentCls: o,
    popoverColor: n,
    titleMinWidth: t,
    fontWeightStrong: a,
    innerPadding: l,
    boxShadowSecondary: d,
    colorTextHeading: g,
    borderRadiusLG: p,
    zIndexPopup: y,
    titleMarginBottom: v,
    colorBgElevated: O,
    popoverBg: f,
    titleBorderBottom: m,
    innerContentPadding: x,
    titlePadding: C
  } = e;
  return [
    {
      [o]: Object.assign(Object.assign({}, U(e)), {
        position: "absolute",
        top: 0,
        // use `left` to fix https://github.com/ant-design/ant-design/issues/39195
        left: {
          _skip_check_: !0,
          value: 0
        },
        zIndex: y,
        fontWeight: "normal",
        whiteSpace: "normal",
        textAlign: "start",
        cursor: "auto",
        userSelect: "text",
        transformOrigin: "var(--arrow-x, 50%) var(--arrow-y, 50%)",
        "--antd-arrow-background-color": O,
        width: "max-content",
        maxWidth: "100vw",
        "&-rtl": {
          direction: "rtl"
        },
        "&-hidden": {
          display: "none"
        },
        [`${o}-content`]: {
          position: "relative"
        },
        [`${o}-inner`]: {
          backgroundColor: f,
          backgroundClip: "padding-box",
          borderRadius: p,
          boxShadow: d,
          padding: l
        },
        [`${o}-title`]: {
          minWidth: t,
          marginBottom: v,
          color: g,
          fontWeight: a,
          borderBottom: m,
          padding: C
        },
        [`${o}-inner-content`]: {
          color: n,
          padding: x
        }
      })
    },
    // Arrow Style
    Oe(e, "var(--antd-arrow-background-color)"),
    // Pure Render
    {
      [`${o}-pure`]: {
        position: "relative",
        maxWidth: "none",
        margin: e.sizePopupArrow,
        display: "inline-block",
        [`${o}-content`]: {
          display: "inline-block"
        }
      }
    }
  ];
}, Ae = (e) => {
  const {
    componentCls: o
  } = e;
  return {
    [o]: we.map((n) => {
      const t = e[`${n}6`];
      return {
        [`&${o}-${n}`]: {
          "--antd-arrow-background-color": t,
          [`${o}-inner`]: {
            backgroundColor: t
          },
          [`${o}-arrow`]: {
            background: "transparent"
          }
        }
      };
    })
  };
}, We = (e) => {
  const {
    lineWidth: o,
    controlHeight: n,
    fontHeight: t,
    padding: a,
    wireframe: l,
    zIndexPopupBase: d,
    borderRadiusLG: g,
    marginXS: p,
    lineType: y,
    colorSplit: v,
    paddingSM: O
  } = e, f = n - t, m = f / 2, x = f / 2 - o, C = a;
  return Object.assign(Object.assign(Object.assign({
    titleMinWidth: 177,
    zIndexPopup: d + 30
  }, Pe(e)), $e({
    contentRadius: g,
    limitVerticalRadius: !0
  })), {
    // internal
    innerPadding: l ? 0 : 12,
    titleMarginBottom: l ? 0 : p,
    titlePadding: l ? `${m}px ${C}px ${x}px` : 0,
    titleBorderBottom: l ? `${o}px ${y} ${v}` : "none",
    innerContentPadding: l ? `${O}px ${C}px` : 0
  });
}, oe = K("Popover", (e) => {
  const {
    colorBgElevated: o,
    colorText: n
  } = e, t = q(e, {
    popoverBg: o,
    popoverColor: n
  });
  return [Te(t), Ae(t), ze(t, "zoom-big")];
}, We, {
  resetStyle: !1,
  deprecatedTokens: [["width", "titleMinWidth"], ["minWidth", "titleMinWidth"]]
});
var Me = function(e, o) {
  var n = {};
  for (var t in e)
    Object.prototype.hasOwnProperty.call(e, t) && o.indexOf(t) < 0 && (n[t] = e[t]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, t = Object.getOwnPropertySymbols(e); a < t.length; a++)
      o.indexOf(t[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, t[a]) && (n[t[a]] = e[t[a]]);
  return n;
};
const Ve = (e, o, n) => !o && !n ? null : /* @__PURE__ */ r.createElement(r.Fragment, null, o && /* @__PURE__ */ r.createElement("div", {
  className: `${e}-title`
}, M(o)), /* @__PURE__ */ r.createElement("div", {
  className: `${e}-inner-content`
}, M(n))), De = (e) => {
  const {
    hashId: o,
    prefixCls: n,
    className: t,
    style: a,
    placement: l = "top",
    title: d,
    content: g,
    children: p
  } = e;
  return /* @__PURE__ */ r.createElement("div", {
    className: R(o, n, `${n}-pure`, `${n}-placement-${l}`, t),
    style: a
  }, /* @__PURE__ */ r.createElement("div", {
    className: `${n}-arrow`
  }), /* @__PURE__ */ r.createElement(Ee, Object.assign({}, e, {
    className: o,
    prefixCls: n
  }), p || Ve(n, d, g)));
}, Ge = (e) => {
  const {
    prefixCls: o,
    className: n
  } = e, t = Me(e, ["prefixCls", "className"]), {
    getPrefixCls: a
  } = r.useContext(V), l = a("popover", o), [d, g, p] = oe(l);
  return d(/* @__PURE__ */ r.createElement(De, Object.assign({}, t, {
    prefixCls: l,
    hashId: g,
    className: R(n, p)
  })));
}, Le = Ge;
var Fe = function(e, o) {
  var n = {};
  for (var t in e)
    Object.prototype.hasOwnProperty.call(e, t) && o.indexOf(t) < 0 && (n[t] = e[t]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, t = Object.getOwnPropertySymbols(e); a < t.length; a++)
      o.indexOf(t[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, t[a]) && (n[t[a]] = e[t[a]]);
  return n;
};
const He = (e) => {
  let {
    title: o,
    content: n,
    prefixCls: t
  } = e;
  return /* @__PURE__ */ r.createElement(r.Fragment, null, o && /* @__PURE__ */ r.createElement("div", {
    className: `${t}-title`
  }, M(o)), /* @__PURE__ */ r.createElement("div", {
    className: `${t}-inner-content`
  }, M(n)));
}, Xe = /* @__PURE__ */ r.forwardRef((e, o) => {
  var n, t;
  const {
    prefixCls: a,
    title: l,
    content: d,
    overlayClassName: g,
    placement: p = "top",
    trigger: y = "hover",
    children: v,
    mouseEnterDelay: O = 0.1,
    mouseLeaveDelay: f = 0.1,
    onOpenChange: m,
    overlayStyle: x = {}
  } = e, C = Fe(e, ["prefixCls", "title", "content", "overlayClassName", "placement", "trigger", "children", "mouseEnterDelay", "mouseLeaveDelay", "onOpenChange", "overlayStyle"]), {
    getPrefixCls: w
  } = r.useContext(V), s = w("popover", a), [P, S, j] = oe(s), b = w(), T = R(g, S, j), [A, B] = he(!1, {
    value: (n = e.open) !== null && n !== void 0 ? n : e.visible,
    defaultValue: (t = e.defaultOpen) !== null && t !== void 0 ? t : e.defaultVisible
  }), N = (i, c) => {
    B(i, !0), m == null || m(i, c);
  }, E = (i) => {
    i.keyCode === be.ESC && N(!1, i);
  }, k = (i) => {
    N(i);
  };
  return P(/* @__PURE__ */ r.createElement(Ne, Object.assign({
    placement: p,
    trigger: y,
    mouseEnterDelay: O,
    mouseLeaveDelay: f,
    overlayStyle: x
  }, C, {
    prefixCls: s,
    overlayClassName: T,
    ref: o,
    open: A,
    onOpenChange: k,
    overlay: l || d ? /* @__PURE__ */ r.createElement(He, {
      prefixCls: s,
      title: l,
      content: d
    }) : null,
    transitionName: Se(b, "zoom-big", C.transitionName),
    "data-popover-inject": !0
  }), Z(v, {
    onKeyDown: (i) => {
      var c, _;
      /* @__PURE__ */ r.isValidElement(v) && ((_ = v == null ? void 0 : (c = v.props).onKeyDown) === null || _ === void 0 || _.call(c, i)), E(i);
    }
  })));
}), L = Xe;
L._InternalPanelDoNotUseOrYouWillBeFired = Le;
process.env.NODE_ENV !== "production" && (L.displayName = "Popover");
const Ke = L, X = (e) => {
  const {
    size: o,
    shape: n
  } = r.useContext(G), t = r.useMemo(() => ({
    size: e.size || o,
    shape: e.shape || n
  }), [e.size, e.shape, o, n]);
  return /* @__PURE__ */ r.createElement(G.Provider, {
    value: t
  }, e.children);
}, qe = (e) => {
  var o, n, t;
  const {
    getPrefixCls: a,
    direction: l
  } = r.useContext(V), {
    prefixCls: d,
    className: g,
    rootClassName: p,
    style: y,
    maxCount: v,
    maxStyle: O,
    size: f,
    shape: m,
    maxPopoverPlacement: x,
    maxPopoverTrigger: C,
    children: w,
    max: s
  } = e;
  if (process.env.NODE_ENV !== "production") {
    const i = Q("Avatar.Group");
    i.deprecated(!v, "maxCount", "max={{ count: number }}"), i.deprecated(!O, "maxStyle", "max={{ style: CSSProperties }}"), i.deprecated(!x, "maxPopoverPlacement", "max={{ popover: PopoverProps }}"), i.deprecated(!C, "maxPopoverTrigger", "max={{ popover: PopoverProps }}");
  }
  const P = a("avatar", d), S = `${P}-group`, j = Y(P), [b, T, A] = J(P, j), B = R(S, {
    [`${S}-rtl`]: l === "rtl"
  }, A, j, g, p, T), N = xe(w).map((i, c) => Z(i, {
    key: `avatar-key-${c}`
  })), E = (s == null ? void 0 : s.count) || v, k = N.length;
  if (E && E < k) {
    const i = N.slice(0, E), c = N.slice(E, k), _ = (s == null ? void 0 : s.style) || O, W = ((o = s == null ? void 0 : s.popover) === null || o === void 0 ? void 0 : o.trigger) || C || "hover", D = ((n = s == null ? void 0 : s.popover) === null || n === void 0 ? void 0 : n.placement) || x || "top", $ = Object.assign(Object.assign({
      content: c
    }, s == null ? void 0 : s.popover), {
      overlayClassName: R(`${S}-popover`, (t = s == null ? void 0 : s.popover) === null || t === void 0 ? void 0 : t.overlayClassName),
      placement: D,
      trigger: W
    });
    return i.push(/* @__PURE__ */ r.createElement(Ke, Object.assign({
      key: "avatar-popover-key",
      destroyTooltipOnHide: !0
    }, $), /* @__PURE__ */ r.createElement(te, {
      style: _
    }, `+${k - E}`))), b(/* @__PURE__ */ r.createElement(X, {
      shape: m,
      size: f
    }, /* @__PURE__ */ r.createElement("div", {
      className: B,
      style: y
    }, i)));
  }
  return b(/* @__PURE__ */ r.createElement(X, {
    shape: m,
    size: f
  }, /* @__PURE__ */ r.createElement("div", {
    className: B,
    style: y
  }, N)));
}, Ue = qe, ne = te;
ne.Group = Ue;
const Qe = ne;
function Ye(e) {
  var t;
  const o = me(e.colorIndex), n = {
    ...e.style,
    background: e.initials ? o : (t = e.style) == null ? void 0 : t.backgroundColor
  };
  return /* @__PURE__ */ pe.jsx(Qe, { ...e.avatarProps, style: n, className: e.className, children: e.initials });
}
function Ze() {
}
Ze.Names = Ye;
export {
  Ze as G,
  Ke as P
};
//# sourceMappingURL=GrowAvatar-DJSlhesM.mjs.map
